import * as ActionTypes from './ActionType';

export const EnableAddRequestAction = (params) => {
    return {
        type: ActionTypes.ONBOARDING_ENABLE_ADD_REQUEST,
        params
    }
}